/**
 * Konkord: a category for people still on the Stoat app ("👀 Só no app do Stoat",
 * asking them to come over). It stays on the server for them and is only left
 * out of the list here. Nothing on the server can tell the two apps apart, so
 * this is decided by the category's name.
 */
export function isStoatOnlyCategory(title: string | undefined) {
  return /s[oó] no app do stoat/i.test(title ?? "");
}

/**
 * The order to save after dragging categories: those not on screen keep their
 * place at the end, or saving would delete them from the server
 */
export function withHiddenCategories(
  ordered: string[],
  categories: { id: string; title?: string }[],
) {
  return [
    ...ordered,
    ...categories
      .filter(
        (category) =>
          isStoatOnlyCategory(category.title) && !ordered.includes(category.id),
      )
      .map((category) => category.id),
  ];
}
